module.exports = __webpack_public_path__ + "static/img/naniungo_schriftzug.00899248.png";